/**
 * Periodically checks if a new version of the app has been deployed.
 * When detected, reloads the page so users always see the latest version
 * without needing to clear cache or cookies.
 */

let currentHash: string | null = null;

async function fetchAppHash(): Promise<string | null> {
  try {
    const res = await fetch("/index.html", {
      cache: "no-cache",
      headers: { "Cache-Control": "no-cache" },
    });
    if (!res.ok) return null;
    const text = await res.text();
    // Extract hashed JS entry point — changes on every build
    const match = text.match(/src="\/assets\/[^"]+"/);
    return match ? match[0] : text.length.toString();
  } catch {
    return null;
  }
}

export async function startVersionCheck(intervalMs = 5 * 60 * 1000) {
  // Capture the current version on first load
  currentHash = await fetchAppHash();
  if (!currentHash) return;

  setInterval(async () => {
    // Don't check if user is filling out a form (active input/textarea)
    const active = document.activeElement;
    if (
      active &&
      (active.tagName === "INPUT" ||
        active.tagName === "TEXTAREA" ||
        (active as HTMLElement).isContentEditable)
    ) {
      return;
    }

    const newHash = await fetchAppHash();
    if (newHash && newHash !== currentHash) {
      // New deploy detected — reload on next navigation or quietly now
      if (document.hidden) {
        // Tab is in background — reload immediately
        window.location.reload();
      } else {
        // Tab is visible — reload to get new version
        currentHash = newHash; // prevent repeated reloads
        window.location.reload();
      }
    }
  }, intervalMs);
}
